import { useState, useEffect, useRef } from 'react';
import { API, getAuthHeader } from '../App';
import axios from 'axios';
import { toast } from 'sonner';
import { MessageSquare, Send, Users } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';

function MensagemItem({ msg, isMe }) {
  const formatTime = function(d) {
    if (!d) return '';
    return new Date(d).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className={'flex ' + (isMe ? 'justify-end' : 'justify-start')}>
      <div className={'max-w-[70%] rounded-2xl px-4 py-2 ' + (isMe ? 'bg-blue-600 text-white rounded-br-sm' : 'bg-white border rounded-bl-sm')}>
        {!isMe && (
          <p className="text-xs text-slate-500 mb-1 font-medium">{msg.remetente_nome}</p>
        )}
        <p className="text-sm">{msg.mensagem}</p>
        <p className={'text-xs mt-1 ' + (isMe ? 'text-blue-200' : 'text-slate-400')}>
          {formatTime(msg.created_at)}
        </p>
      </div>
    </div>
  );
}

export default function ChatInternoPage() {
  const [mensagens, setMensagens] = useState([]);
  const [novaMensagem, setNovaMensagem] = useState('');
  const [loading, setLoading] = useState(true);
  const messagesEndRef = useRef(null);
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  useEffect(function() {
    loadMensagens();
    const interval = setInterval(loadMensagens, 5000);
    return function() { clearInterval(interval); };
  }, []);

  useEffect(function() {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [mensagens]);

  const loadMensagens = async function() {
    try {
      const res = await axios.get(API + '/chat/mensagens', { headers: getAuthHeader() });
      setMensagens(res.data.mensagens || []);
    } catch (error) {
      console.error('Erro ao carregar mensagens');
    }
    setLoading(false);
  };

  const enviar = async function() {
    if (!novaMensagem.trim()) return;
    try {
      await axios.post(
        API + '/chat/enviar?mensagem=' + encodeURIComponent(novaMensagem),
        {},
        { headers: getAuthHeader() }
      );
      setNovaMensagem('');
      loadMensagens();
    } catch (error) {
      toast.error('Erro ao enviar');
    }
  };

  const renderMensagens = function() {
    if (loading) {
      return (
        <div className="text-center py-8">
          <div className="animate-spin w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full mx-auto"></div>
        </div>
      );
    }
    
    if (mensagens.length === 0) {
      return (
        <div className="text-center py-8 text-slate-500">
          <Users className="w-12 h-12 mx-auto mb-2 text-slate-300" />
          <p>Nenhuma mensagem ainda</p>
          <p className="text-sm">Seja o primeiro a enviar!</p>
        </div>
      );
    }

    return mensagens.map(function(msg) {
      const isMe = msg.remetente_id === user.id;
      return <MensagemItem key={msg.id} msg={msg} isMe={isMe} />;
    });
  };

  return (
    <div className="flex flex-col h-[calc(100vh-120px)] bg-white rounded-xl border overflow-hidden" data-testid="chat-interno-page">
      <div className="p-4 border-b bg-gradient-to-r from-blue-600 to-blue-700 text-white">
        <h1 className="text-xl font-bold flex items-center gap-2">
          <MessageSquare className="w-6 h-6" />
          Chat Interno
        </h1>
        <p className="text-blue-200 text-sm">Comunicação da equipe</p>
      </div>

      <div className="flex-1 overflow-y-auto p-4 space-y-3 bg-slate-50">
        {renderMensagens()}
        <div ref={messagesEndRef} />
      </div>

      <div className="p-4 border-t bg-white">
        <div className="flex gap-2">
          <Input
            placeholder="Digite sua mensagem..."
            value={novaMensagem}
            onChange={function(e) { setNovaMensagem(e.target.value); }}
            onKeyPress={function(e) { if (e.key === 'Enter') enviar(); }}
            data-testid="chat-input"
          />
          <Button onClick={enviar} disabled={!novaMensagem.trim()} className="bg-blue-600" data-testid="chat-send-btn">
            <Send className="w-5 h-5" />
          </Button>
        </div>
      </div>
    </div>
  );
}
